import React, { useState, useContext, useCallback, useRef } from "react";
import { Spin, Input, message } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { LoginFormContext } from "../../utils";
import { BackNav } from "../../comps";
import { TeamUserInfo, UserTeamInfoInterface } from "@/types/LoginPage";
import { useTranslation } from "react-i18next";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import InputWithCtr from "@/components/TeamManagement/InputWithCtr";
import styles from "../../index.module.less"
import _ from "lodash";
export default function JoinPersonalTeam({
  goBack,
  isLogin = true
}: {
  goBack: () => void;
  isLogin: boolean;
}) {
  const { t } = useTranslation("common");
  const { service, onGlobalError, authInfo: authData, focusSDK } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const { authInfo: loginAuthInfo, enterApplication } = useContext(LoginFormContext);
  const authInfo = loginAuthInfo || authData;
  const [userName, setUserName] = useState<string | undefined>("");
  const [loading, setLoading] = useState(false);
  const teamsInfoRef = useRef<UserTeamInfoInterface | null>(null);

  const loadingComp = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />} />
  );
  const doEnterApplication = useCallback(
    (content) => {
      let info: TeamUserInfo | null = null;
      const userInfo = _.pick(authData, [
        "mobile",
        "email",
        "hasPassword",
        "hasBindMobile",
        "hasBindEmail"
      ]);
      const teamInfoList =
        teamsInfoRef.current?.teamInfoList?.map((item) => {
          const data: TeamUserInfo = {
            ...item,
            ...userInfo
          };
          if (content.teamId === item.teamId) {
            info = data;
          }
          return data;
        }) || [];
      if (!info || !teamInfoList) {
        message.warning(t("createTeam.error"));
        return;
      }
      if (isLogin) {
        return enterApplication(info);
      } else {
        focusSDK.switchTeam(content.teamId, teamInfoList);
      }
    },
    [isLogin, enterApplication, authData]
  );
  function onUserNameChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setUserName(e.target.value);
  }
  const doJoinPersonalTeam = useCallback(
    async (userName) => {
      try {
        setLoading(true);
        //  console.log(authInfo, "authInfo>doJoinPersonalTeam", userName);
        const content: TeamUserInfo = await service.focusService.joinPersonalTeam({
          userId: authInfo.userId,
          userName: userName || ""
        });
        if (content) {
          const teamsInfo = await service.focusService.getUserTeamInfo();
          teamsInfoRef.current = teamsInfo;
          doEnterApplication(content);
        }
        setLoading(false);
      } catch (e) {
        // console.log(e, "e>ls");
        // onGlobalError(e);
        message.warning(e?.errorMsg || e?.msg || t("createTeam.personalError"));
      }
    },
    [authInfo, doEnterApplication, service]
  );
  const userNameInput = (
    <>
      <div>
        <BackNav clickHandle={goBack} title={t("login.back")} subtitle={t("login.inputUserName")} />
      </div>
      <div
        style={{
          paddingBottom: 44
        }}
      >
        <div className={styles.mobileForm}>
          <span className={styles.mobileInputText}>{t("login.inputUserNameText")}</span>
          <Input
            placeholder={t("login.inputUserNameTextPlaceholder")}
            autoComplete="off"
            allowClear
            className={styles.mobileInput}
            autoFocus
            onChange={onUserNameChange}
            maxLength={50}
            style={{marginTop: 8}}
          />
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          width: 320,
          bottom: 45
        }}
      >
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {
            if (!userName || loading) return;
            doJoinPersonalTeam(userName);
          }}
          className={styles.btn}
          style={
            !loading && userName && userName.length
              ? {
                  opacity: 1,
                  cursor: "pointer"
                }
              : {
                background: "#BABFC5"
              }
          }
        >
          {loading && <div>{loadingComp}</div>}
          <div
            style={{
              margin: 12,
              fontSize: 14,
              color: "rgb(255, 255, 255)"
            }}
          >
            {t("nextStep")}
          </div>
        </div>
      </div>
    </>
  );

  return <div className={styles.mobileForm}>{userNameInput}</div>;
}
